module.exports = __webpack_public_path__ + "static/media/g-1-d.84187a3f.jpg";